import {
  Box,
  Button,
  FormControl,
  Modal,
  SelectChangeEvent,
  TextField,
} from '@mui/material';
import { useCallback, useState } from 'react';
import { useUpdateCommentMutation } from '~/features/accounts/model/api/accounts-api';
import { IModalCommentProps } from '~/shared/types/types';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  bgcolor: 'background.paper',
  borderRadius: '24px',
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

export const ModalComment: React.FC<IModalCommentProps> = ({
  open,
  handleClose,
  account,
}) => {
  const [comment, setComment] = useState(account.comment);

  const handleChange = (event: SelectChangeEvent) => {
    setComment(event.target.value as string);
  };
  const account_id = account.id;

  const [updateComment] = useUpdateCommentMutation();

  const commentSubmit = useCallback(() => {
    updateComment({ account_id, comment });
    handleClose();
    setComment('');
  }, [account_id, comment, handleClose, updateComment]);

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description">
        <Box sx={{ ...style, width: 400 }}>
          <h2 id="child-modal-title">Комментарий</h2>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: '24px',
              pb: '12px',
            }}></Box>

          <FormControl fullWidth>
            <TextField value={comment} onChange={handleChange}></TextField>
          </FormControl>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: '12px',
              pt: '12px',
              alignContent: 'end',
            }}>
            <Button onClick={handleClose}>Отменить</Button>
            <Button onClick={commentSubmit} variant="contained">
              Сохранить
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};
